export default "__VITE_ASSET__fBfx7xKd__"